import React from "react";
import "./services.css";
import { motion } from "framer-motion";
import { fadeVariants } from "../../Animations/fadeVariants.js";
import Footer from "../../Components/Footer/Footer.jsx";
import AnimatedUnderline from "../../Animations/AnimatedUnderline.jsx";

function Services() {
  return (
    <motion.div
      variants={fadeVariants}
      initial="initial"
      animate="animate"
      exit="exit"
    >
      <div className="services-container">
        <div className="header-1">
          <a href="/" className="home-button">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="24px"
              viewBox="0 -960 960 960"
              width="24px"
              fill="#1f1f1f"
            >
              <path d="M400-80 0-480l400-400 71 71-329 329 329 329-71 71Z" />
            </svg>
          </a>
          <h1 className="header-2">Services</h1>
        </div>
        <div className="services-box">
          <div className="services-containers">
            <h3 className="header-3">Lunch Walks - $35</h3>
            <ul className="services-list">
              <li>Monday - Friday 11:30 AM - 2:30 PM</li>
              <li>
                Walks are 35 minutes long. (Often longer when weather and
                scheduling permit)
              </li>
              <li>We also offer weekend walk drop-ins upon request</li>
              <li>Additional sibling dog $15</li>
            </ul>
          </div>
          <div className="services-containers">
            <h3 className="header-3">Lunch Potty Walks - $25</h3>
            <ul className="services-list">
              <li>Monday - Friday 11:30 AM - 2:30 PM</li>
            </ul>
          </div>
          <div className="services-containers">
            <h3 className="header-3">Overnight Boardings - $100</h3>
            {/* <p className="intake-subtitle fade-in-5">
                We usually provide full 1-on-1, crate-free boarding in our home,
                keeping group sizes strictly limited so your pup gets personal
                care. But will occasionally host two dogs at once if we know
                they get along wonderfully and will enjoy the company. Round
                trip pick-up and drop-off are included to fit your travel plans.
              </p> */}
            <ul className="services-list">
              <li>100% crate-free environment in a cozy home setting</li>
              <li>
                Small group capacity to ensure individual love and supervision
              </li>
              <li>
                Carefully matched playmates for dogs who enjoy friendly company
              </li>
              <li>Complimentary pick-up & drop-off included</li>
              <li>Additional sibling dog $50</li>
            </ul>
          </div>
          <div className="services-containers">
            <h3 className="header-3">Solo Overnight Boardings - $175</h3>
            <ul className="services-list">
              <li>Exclusive one-on-one care with no other dogs present</li>
              <li>
                Ideal for dogs who prefer individual attention or solitude
              </li>
              <li>Complimentary pick-up & drop-off included</li>
            </ul>
          </div>
          <br />
          <p className="intake-subtitle-2">
            No additional fees for holidays or weekends, ever.
          </p>
        </div>
        <div className="videos">
          <h1 className="helpful-info">Helpful Informations</h1>
          <AnimatedUnderline />
          <div className="simple-pricing">
            <h2 className="header-3">How to Book & Pay</h2>
            <p>
              We try to stay flexible, as many clients’ schedules change week to
              week. A day’s notice is appreciated, but you’re always welcome to
              reach out the same morning to request a lunch walk, and we’ll do
              our best to accommodate. Payment is collected after the walk,
              allowing for easy adjustments if plans change.
            </p>
          </div>
          <div className="simple-pricing">
            <h2 className="header-3">
              First-Time Booking: Consider a Trial Night
            </h2>
            <p>
              A trial night is an introductory overnight stay to help your dog
              become familiar with us, our home, and our routine before a longer
              boarding period. This allows your dog to adjust in a low-pressure
              setting, making their future stay more comfortable and stress-free
              while you are away. Many clients choose to schedule a trial night
              before their first full boarding, as it helps ensure a smooth and
              positive experience for both the dog and the owner.
            </p>
          </div>
          <div className="simple-pricing">
            <h2 className="header-3">Simple & Fair Pricing</h2>
            <p>
              Unlike many dog walkers, we don’t use variable pricing. We believe
              in keeping things simple and fair, so our walks are priced the
              same for every pup. <br /> <br /> The only exception is for senior
              or ill dogs who may only need a short bathroom break rather than a
              full walk. If your dog has special needs or conditions, please
              don’t hesitate to reach out — we’re always happy to discuss
              pricing with care and flexibility.
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </motion.div>
  );
}

export default Services;
